module.exports = __webpack_public_path__ + "~@/assets/img/4_sort.00cea96c.png";